import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  CompletionRateListContext,
  StaticsContext,
  ProfileContext,
} from '../../contexts'
import { deleteCookie } from '../../utils/manageCookie'
import useModal from '../../hooks/useModal'

import * as S from '../../components/main/Main.styles'
import { AiMentoringBtn, BasicBtn } from '../../components/Buttons'
import TodayStudy from '../../components/main/TodayStudy'
import TodayDailyLog from '../../components/main/TodayDailyLog'
import TodayTodo from '../../components/main/TodayTodo'
import YearlyStudy from '../../components/main/YearlyStudy'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'

import { ReactComponent as ColoredSmileIcon } from '../../assets/images/smile/colored_smile_icon.svg'

function MainContents() {
  const [completionRateList,setCompleteRateList] = useState([])
  const [statics, setStatics] = useState({})
  const { docs } = useContext(ProfileContext)
  const navigate = useNavigate()
  const { openModal } = useModal()

  return (
    <S.ContentsLayout>
      {/* TODO Provider가 여러 개 중첩 되는 것에 대한 리팩토링 */}
      <CompletionRateListContext.Provider value={{ completionRateList, setCompleteRateList }}>
        <StaticsContext.Provider value={{ statics, setStatics }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '56px',
              marginBottom: '20px',
            }}
          >
            <AiMentoringBtn
              onClick={() => openModal({ type: 'aiMentoring'})}
              height="40px"
              width="100px"
            >
              <AutoAwesomeOutlinedIcon sx={{ fontSize: 22 }} />
              AI 멘토
            </AiMentoringBtn>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <span>
                <strong>{docs.nickname}</strong>님 안녕하세요
              </span>
              <ColoredSmileIcon width="30px" />
              <BasicBtn
                onClick={() => {
                  deleteCookie('akive_user')
                  navigate('/')
                }}
                height="40px"
                width="100px"
              >로그아웃
              </BasicBtn>
            </div>
          </div>
          <TodayStudy/>
          <S.FlexContainer>
            <TodayDailyLog/>
            <TodayTodo/>
          </S.FlexContainer>
          <YearlyStudy/>
        </StaticsContext.Provider>
      </ CompletionRateListContext.Provider>
    </S.ContentsLayout>
  )
}

export default MainContents
